import React from "react";
import "../trends/components/Trends.module.css";
import CausesList from "../trends/components/CausesList";
import { maxBarHeight } from "../trends/components/constants";
import BarChart from "../trends/components/BarChart";
import styles from "../trends/components/Trends.module.css";
import { useNavigate } from "react-router-dom";
import { MOOD_COLORS } from "constants/moodColors";

const DEMO_WEEKDAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri"];

const halfBar = maxBarHeight / 2;

/**
 * Mon–Fri: each day has 1 or 2 segment heights only (one solid bar or a 50/50 stack).
 */
const DEMO_BAR_CHART_DATA = [
  [
    {
      totalHeight: maxBarHeight,
      segments: [{ color: MOOD_COLORS.Flow, height: maxBarHeight }],
    },
    {
      totalHeight: maxBarHeight,
      segments: [
        { color: MOOD_COLORS.Confident, height: halfBar },
        { color: MOOD_COLORS.Flow, height: halfBar },
      ],
    },
    {
      totalHeight: maxBarHeight,
      segments: [{ color: MOOD_COLORS.Apathy, height: maxBarHeight }],
    },
    {
      totalHeight: maxBarHeight,
      segments: [
        { color: MOOD_COLORS.Anxiety, height: halfBar },
        { color: MOOD_COLORS.Confident, height: halfBar },
      ],
    },
    {
      totalHeight: maxBarHeight,
      segments: [{ color: MOOD_COLORS.Flow, height: maxBarHeight }],
    },
  ],
];

const DEMO_MOOD_PERCENTAGES = {
  Apathy: 12,
  Flow: 38,
  Anxiety: 10,
  Confident: 40,
};

const DEMO_MAIN_CAUSES: Record<string, number> = {
  "Clear priorities": 4,
  "Time with team": 3,
};

export default function DemoTrends() {
  const navigate = useNavigate();

  return (
    <>
      <div className={styles["trends-page-container"]}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "16px",
          }}
        ></div>
        <div className={styles["content-container"]}>
          <div className={styles["challenged-heading-wrap"]}>
            <h2>After a few check-ins, you’ll see patterns like this</h2>
          </div>

          <br />

          <h3>Feelings</h3>

          <BarChart
            barChartData={DEMO_BAR_CHART_DATA}
            weekdayLabels={DEMO_WEEKDAY_LABELS}
            maxBarHeight={maxBarHeight}
          />

          <CausesList filteredCauses={DEMO_MAIN_CAUSES} />
        </div>
      </div>
      <button
        className="proceed-button"
        onClick={() => {
          navigate("/app/demo-team-invite");
        }}
      >
        View team insights →
      </button>
    </>
  );
}
